import { DesktopFlyoutMenuComponent } from '../components/desktop-flyout-menu/desktop-flyout-menu.component';
import { DesktopMegaMenuComponent } from '../components/desktop-mega-menu/desktop-mega-menu.component';
import { MobileFlyoutMenuComponent } from '../components/mobile-flyout-menu/mobile-flyout-menu.component';
import { MobileMegaMenuComponent } from '../components/mobile-mega-menu/mobile-mega-menu.component';
import { AccordionComponent } from '../snippet/accordion/accordion.component';
import { ArticleCardComponent } from '../snippet/article-card/article-card.component';
import { ButtonComponent } from '../snippet/button/button.component';
import { CardComponent } from '../snippet/card/card.component';
import { CopperComponent } from '../snippet/copper/copper.component';
import { FeatureComponent as SnippetFeatureComponent } from '../snippet/feature/feature.component';
import { HtmlComponent } from '../snippet/html/html.component';
import { ImageComponent } from '../snippet/image/image.component';
import { LinkComponent } from '../snippet/link/link.component';
import { MenuComponent } from '../snippet/menu/menu.component';
import { MessageComponent } from '../snippet/message/message.component';
import { RichtextComponent } from '../snippet/richtext/richtext.component';
import { StockistComponent } from '../snippet/stockist/stockist.component';
import { TallyComponent } from '../snippet/tally/tally.component';
import { AccordionCategoriesComponent } from './accordion-categories/accordion-categories.component';
import { AccordionGroupComponent } from './accordion-group/accordion-group.component';
import { CallOutComponent } from './call-out/call-out.component';
import { ContactFormComponent } from './contact-form/contact-form.component';
import { DisplayTextComponent } from './display-text/display-text.component';
import { FaqsComponent } from './faqs/faqs.component';
import { FeatureComponent } from './feature/feature.component';
import { FeaturedArticlesComponent } from './featured-articles/featured-articles.component';
import { GridComponent } from './grid/grid.component';
import { HeroComponent } from './hero/hero.component';
import { InfoSheetComponent } from './info-sheet/info-sheet.component';
import { InstagramComponent } from './instagram/instagram.component';
import { PageComponent } from './page/page.component';
import { PosterComponent } from './poster/poster.component';
import { ReviewsComponent } from './reviews/reviews.component';
import { TickerComponent } from './ticker/ticker.component';
import { ZoneComponent } from './zone/zone.component';

let Components = {
  page: PageComponent,
  hero: HeroComponent,
  grid: GridComponent,
  ticker: TickerComponent,
  zone: ZoneComponent,
  poster: PosterComponent,
  'call-out': CallOutComponent,
  faqs: FaqsComponent,
  feature: FeatureComponent,
  reviews: ReviewsComponent,
  'article-card': ArticleCardComponent,
  'featured-articles': FeaturedArticlesComponent,
  'mobile-mega-menu': MobileMegaMenuComponent,
  'desktop-mega-menu': DesktopMegaMenuComponent,
  'mobile-flyout-menu': MobileFlyoutMenuComponent,
  'desktop-flyout-menu': DesktopFlyoutMenuComponent,
  'display-text': DisplayTextComponent,
  'info-sheet': InfoSheetComponent,
  'contact-form': ContactFormComponent,
  's-feature': SnippetFeatureComponent,
  's-card': CardComponent,
  's-message': MessageComponent,
  's-image': ImageComponent,
  's-button': ButtonComponent,
  's-menu': MenuComponent,
  's-tally': TallyComponent,
  's-stockist': StockistComponent,
  's-copper': CopperComponent,
  's-link': LinkComponent,
  's-grid': GridComponent,
  's-accordion': AccordionComponent,
  's-richtext': RichtextComponent,
  'accordion-categories': AccordionCategoriesComponent,
  'accordion-group': AccordionGroupComponent,
  's-html': HtmlComponent,
  instagram: InstagramComponent,
};

export { Components };
